// The one place that knows how platform+account addressing is spelled, both in the bulk
// cross-listing setup page's local state (targetAccounts) and in the backend's per-account
// batch results.

// A target account value is either a single id, an array of ids, or absent. This is the
// one rule that turns any of those into a plain array, shared by every function below.
function toAccountIdArray(value) {
  if (value === null || value === undefined) return [];
  return Array.isArray(value) ? [...value] : [value];
}

// Turn a { platform: id | [id, ...] | null } map into { platform: [id, ...] } for every
// platform, without touching the object or arrays passed in.
export function normalizeTargetAccounts(targetAccounts) {
  const normalized = {};
  Object.entries(targetAccounts || {}).forEach(([platform, value]) => {
    normalized[platform] = toAccountIdArray(value);
  });
  return normalized;
}

// Same normalization as above, scoped to one platform. A platform absent from
// targetAccounts is the same as an empty selection.
export function accountIdsFor(targetAccounts, platform) {
  return toAccountIdArray((targetAccounts || {})[platform]);
}

// Builds the backend's batch-result key for one platform + account, e.g. 'ebay:370'.
// A missing integrationId (extension platforms run one account at a time) means the
// bare platform name, e.g. 'poshmark'.
export function platformAccountKey(platform, integrationId) {
  return integrationId === null || integrationId === undefined
    ? platform
    : `${platform}:${integrationId}`;
}

// Inverse of platformAccountKey. The integrationId is a Number when the key carries one
// and it is actually numeric; otherwise (bare key, or a non-numeric suffix) it is null.
export function parsePlatformResultKey(key) {
  const separatorIndex = key.indexOf(':');
  if (separatorIndex === -1) {
    return { platform: key, integrationId: null };
  }

  const platform = key.slice(0, separatorIndex);
  const idPart = key.slice(separatorIndex + 1);
  const numericId = Number(idPart);
  const integrationId = idPart !== '' && Number.isFinite(numericId) ? numericId : null;

  return { platform, integrationId };
}
